import Vue from 'vue'
// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
export default new Vue() // <-- in this case access using import EventBus



// WEBPACK FOOTER //
// ./src/controllers/EventBus.js